'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';

var _default = /*#__PURE__*/function (_Component) {
  _inherits(_default, _Component);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isExpanded: true,
      valueExists: false
    };

    _this.setLabelStates = function (isExpanded, valueExists) {
      _this.setState({
        isExpanded: isExpanded,
        valueExists: valueExists
      });
    };

    _this.inputFocused = function () {
      _this.setLabelStates(false, false);
    };

    _this.inputBlurred = function () {
      if (_this.getInputValue()) {
        _this.setLabelStates(false, true);
      } else {
        _this.setLabelStates(true, false);
      }
    };

    _this.getInputValue = function () {
      var inputVal = findDOMNode(_this.refs.input).value;
      return inputVal ? inputVal.trim() : undefined;
    };

    _this.getContainerClassName = function (isValid) {
      return !isValid() ? "invalid" : "";
    };

    _this.getLabelClassName = function () {
      return classNames('label-text', _this.state.isExpanded && "expanded", _this.state.valueExists && 'value-exists');
    };

    _this.renderNoticeText = function () {
      var noticeText = _this.props.noticeText;

      if (!noticeText) {
        return null;
      }

      return /*#__PURE__*/_jsx("div", {
        className: "notice-text",
        children: noticeText
      });
    };

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.getInputValue()) {
        // Rearrange the class structure if a value exists
        this.setLabelStates(false, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          labelText = _this$props.labelText,
          errorText = _this$props.errorText,
          isValid = _this$props.isValid,
          onChange = _this$props.onChange,
          _onBlur = _this$props.onBlur,
          value = _this$props.value,
          type = _this$props.type;
      return /*#__PURE__*/_jsxs("div", {
        className: this.getContainerClassName(isValid),
        children: [/*#__PURE__*/_jsxs("label", {
          children: [/*#__PURE__*/_jsx("span", {
            ref: "label",
            className: this.getLabelClassName(),
            children: labelText
          }), /*#__PURE__*/_jsx("input", {
            ref: "input",
            "data-test-id": this.props['data-test-id'],
            type: type,
            onFocus: this.inputFocused,
            onBlur: function onBlur(e) {
              if (typeof _onBlur === 'function') {
                _onBlur(e);
              }

              _this2.inputBlurred();
            },
            autoCapitalize: "off",
            autoCorrect: "off",
            onChange: onChange,
            value: value
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            className: "error-text",
            children: errorText
          })]
        }), this.renderNoticeText()]
      });
    }
  }]);

  return _default;
}(Component);

export { _default as default };